import en_US from './en-US';

const Locales = {
	...en_US
};

export default Locales;
